import { createDeferredI18n } from "#/shared/composables/useI18n";

import fallbackMessages from "#/shared/i18n/frontend.translatable_field.json";

// `sp-translatable-field` is a registered component rather than an app, so it has no plugin hook
// to install the instance on — the strings are read off the global composer directly.
const { i18n, ready: whenI18nReady } = createDeferredI18n({ key: "translatable_field", fallbackMessages });

export { whenI18nReady };

/**
 * Translates a translatable-field string. Keys are relative to `frontend.translatable_field`,
 * which the i18n endpoint serves as the message root, and resolve per client through that
 * client's own locale files.
 *
 * @param {String} key
 * @param {Object} [values] - Values for the named placeholders of the message.
 * @returns {String}
 */
export function t(key, values) {
  return values ? i18n.global.t(key, values) : i18n.global.t(key);
}
